import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-date-from-to-type',
  templateUrl: './fb-basic-input-checklist-date-from-to-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-date-from-to-type.component.css']
})
export class FbCoreBasicInputChecklistDateFromToTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'date_from_and_to',
                placeholder: 'DD/MM/YY',
                placeholder2: 'DD/MM/YY'
            };
        }
    }
}
